import { render, staticRenderFns } from "./DeleteCourseTopicConfirmation.vue?vue&type=template&id=1783807e"
import script from "./DeleteCourseTopicConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteCourseTopicConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports